/**
 * Los ids del DOM a los que se navega DENTRO del Panel. Viven aparte para que quien apunta (el
 * header) no tenga que importar a quien es apuntado (la card, con todos sus modales).
 */

/** La card de Plataformas: el «Vincular cuenta» del header baja hasta acá (card jaM5imSj). */
export const PLATFORMS_CARD_ID = 'pnl-platforms';
